import ModalOrBottomSheetWrapper from './ModalOrBottomSheetWrapper.js';
export { default } from './ModalOrBottomSheetWrapper.js';
//# sourceMappingURL=index.js.map
